import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["copiedIndicator", "copyButton"];

  copy(event) {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(event.currentTarget.dataset.textToCopy);

    this.#showCopiedIndicator();
  }

  disconnect() {
    this.#clearCopiedIndicatorTimeout();
  }

  #showCopiedIndicator() {
    this.#clearCopiedIndicatorTimeout();

    if (!this.hasCopiedIndicatorTarget) {
      return;
    }

    if (this.hasCopyButtonTarget) {
      this.copyButtonTarget.classList.add("hidden");
    }

    this.copiedIndicatorTarget.classList.remove("hidden");

    this.hideIndicatorTimeout = setTimeout(() => {
      this.copiedIndicatorTarget.classList.add("hidden");
      if (this.hasCopyButtonTarget) {
        this.copyButtonTarget.classList.remove("hidden");
      }
    }, 3000);
  }

  #clearCopiedIndicatorTimeout() {
    if (this.hideIndicatorTimeout) {
      clearTimeout(this.hideIndicatorTimeout);
      this.hideIndicatorTimeout = null;
    }
  }
}
